export const API_CONFIG = {
  API_KEY: import.meta.env.VITE_API_KEY,
  FRANCHISE_ID: import.meta.env.VITE_FRANCHISE_ID || '402',
  BASE_URL: import.meta.env.VITE_BASE_URL || 'https://api.agencycms.com',
}

export interface FranchiseData {
  id: number
  name: string
  subdomain: string
  topbar_color: string
  button_color: string
  main_background_color: string
  secondary_background_color: string
  accent_color: string
  telephone: string
  emergency_telephone: string
  email: string
  address: string
  facebook: string
  instagram: string
  whatsapp: string
  linkedin?: string
  catch_phrase: string
  cta_text: string
  logo_url: string
  footer_logo_url: string
  general_logo_url: string
  background_image_url: string
  linkedin?: string
}

export interface Destination {
  id: number
  name: string
  uuid: string
  country_code: string | null
  intro: string | null
  slug: string
  google_places_id: string | null
  latitude: number | null
  longitude: number | null
}

export interface PackageType {
  id: number
  name: string
  description: string
  slug: string
}

export interface Photo {
  id: number
  url: string
  large_url: string
  thumb_url: string
}

export interface Package {
  id: number
  uuid: string
  name: string
  description: string
  intro: string
  inclusions: string
  exclusions: string
  terms?: string
  published: boolean
  valid_from: string
  valid_to: string
  travel_from: string | null
  travel_to: string | null
  flightsite_validity?: string | null
  price_cents: number
  price_currency: string
  nights: number
  flight_included: boolean
  hotel_included: boolean
  transfer_included: boolean
  guided_tour: boolean
  self_drive: boolean
  total_pax: string
  destination_id: number
  destination?: Destination
  slug: string
  cover_photo: {
    url: string
    large_url: string
    thumb_url: string
  } | null
  photos?: Photo[]
  scraped_cover_photo?: string
  location?: string
  beachcomber_reference?: string
  secondary_reference?: string
  featured: boolean
  // Computed fields for UI
  formatted_price?: string
  duration?: string
  dates?: string
  rating?: number
  category?: string
  includes?: string[]
}

export interface PackagesApiResponse {
  franchise_packages: Package[]
  // Add pagination info when available from API
  meta?: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
  }
}

export interface PackageApiResponse {
  package: Package
}

export interface PackagesResponse {
  packages: Package[]
  pagination: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
    has_next: boolean
    has_prev: boolean
  }
}

export interface BlogPost {
  id: number
  title: string
  description: string
  slug: string
  status: string
  blog_type: string
  franchise_id: number
  user_id: number
  created_at: string
  updated_at: string
  featured_image_file_name: string | null
  featured_image_content_type: string | null
  featured_image_file_size: number | null
  featured_image_updated_at: string | null
  featured_image: {
    url: string
    thumb_url: string
    medium_url: string
  } | null
  // Computed fields for UI
  excerpt?: string
  author_name?: string
  category?: string
  tags?: string[]
}

export interface BlogsApiResponse {
  blogs: BlogPost[]
  meta?: {
    current_page: number
    total_pages: number
    total_entries: number
    per_page?: number
  }
}

export interface BlogApiResponse {
  blog: BlogPost
}

export interface BlogsResponse {
  blogs: BlogPost[]
  pagination: {
    current_page: number
    total_pages: number
    total_count: number
    per_page: number
    has_next: boolean
    has_prev: boolean
  }
}

export interface Comment {
  id: number
  name: string
  email: string
  body: string
  blog_id: number
  user_id: number | null
  created_at: string
  updated_at: string
  published: boolean
}

export interface CommentsApiResponse {
  comments?: Comment[]
}

export interface CreateCommentRequest {
  name: string
  email: string
  body: string
}

export interface CreateCommentApiResponse {
  id: number
  name: string
  email: string
  body: string
  blog_id: number
  user_id: number | null
  created_at: string
  updated_at: string
  published: boolean
}
